// common
import {
  VuexModule,
  Module,
  getModule,
  Mutation,
} from "vuex-module-decorators";
import store from "@/store";

@Module({ dynamic: true, store, name: "Logs", namespaced: true })
class LogsStoreModule extends VuexModule {
  public isSyncInProgress = false;

  @Mutation
  setIsSyncInProgress(status: boolean) {
    this.isSyncInProgress = status;
  }
}

const LogsModule = getModule(LogsStoreModule);
export default LogsModule;
